const state = {
  configs: {},
}
const getters = {
  getConfig: (state) => (key) => state.configs[key],
}
const mutations = {
  setConfig(state, { key, config }) {
    state.configs[key] = config
  },
}
const actions = {
  async loadConfig({ commit }, { key, fileName }) {
    try {
      const jsonPath = `${process.env.VUE_APP_STATIC_CONFIG_PATH}/config/${fileName}?v=${Math.random()}`
      const response = await fetch(jsonPath, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      if (!response.ok) {
        commit('setConfig', { key, config: {}})
        console.error('jsonUrl 请求失败')
        return
      }
      const config = await response.json() || {}
      commit('setConfig', { key, config })
    } catch (error) {
      commit('setConfig', { key, config: {}})
      console.error(error)
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

